import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n3p34d576a: FaireBrandEntity = {
  token: "b_n3p34d576a",
  type: "brand",
  name: "Nette",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a6110112c69933cd4d65edc03f1a1d7aad245b8dbde538d066a7d8ddaf6c856.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/69f82a898f5aff9ca63269b6434112b983605fcaef106e8f3fcd06d80782a9da.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9a6110112c69933cd4d65edc03f1a1d7aad245b8dbde538d066a7d8ddaf6c856.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/69f82a898f5aff9ca63269b6434112b983605fcaef106e8f3fcd06d80782a9da.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 1000,
  rating: 4.3,
  reviewCount: 4,
  isInsider: true,
  description:
    "All of our fragrances are inspired by modern protagonists; they are character studies that lived in my head before being brought to life through scent. A bestselling author of dystopian novels writing in her glass house in the woods. A beautiful young sculptor eating a Japanese pear in her NYC loft in the ‘90s. A tennis player studying English Literature at Oxford in the spring when the roses are in bloom. A powerful mother warrior in gleaming armor dreaming of the lemon tree that grew in front of her childhood home. And you. The most important protagonist of all. I hope our fragrances bring you closer to these imaginary worlds and closer to yourself at the same time.\n\nAll of our fragrances are scientifically proven to boost wellbeing—they increase feelings of mindfulness, confidence, joy, and relaxation—and there’s a poem engraved on every perfume bottle and candle label. We hope Nette serves as an elevation of art and emotion, bringing poetry and good feelings into your everyday life. \n\nWe call it The NetteEffect™: Smell Good. Feel Good. Be Good. \n\nLove,\nCarol Han Pyle, founder and CEO",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:24.209Z",
    importedBy: "entity-db-cli",
  },
};
